import React from 'react';
import PropTypes from 'prop-types';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';

import TileLink from '../../../../components/TileLink/TileLink';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import { getString } from '../../../../helpers/stringHelpers';

class ContactDetailsLandingCard extends React.Component {
  render() {
    const { classes, action } = this.props;

    return (
      <TileLink
        icon={PhoneOutlinedIcon}
        title={getString('contactDetails', 'CONTACT_DETAILS_TITLE')}
        classes={{ avatar: classes.avatar }}
        action={action}
      />
    );
  }
}

export default withStyles(styles, { useTheme: true })(
  ContactDetailsLandingCard
);
